// extracted by mini-css-extract-plugin
module.exports = {"homepage":"Homepage_homepage__25sWw","left":"Homepage_left__2eSsF","right":"Homepage_right__h081U"};